import React from 'react';
import { Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import Button from '../Button';

interface GwaPromoIneligibleModalProps {
  opened: boolean;
  onClose: () => void;
}

/**
 * Tells an adopter whose email has already used the adoption offer that it no longer applies. By the
 * time this shows, the promo is already off the cart, so all that is left is to carry on at the
 * regular price.
 */
export default function GwaPromoIneligibleModal({ opened, onClose }: GwaPromoIneligibleModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      radius={16}
      title={t('gwa_promo_ineligible_title')}
      closeButtonProps={{ 'aria-label': t('close') }}
      styles={{ title: { fontSize: 22, fontWeight: 700 } }}
    >
      <Stack>
        <Text fz={16}>{t('gwa_promo_ineligible_body')}</Text>
        <Button onClick={onClose}>{t('gwa_promo_ineligible_continue')}</Button>
      </Stack>
    </Modal>
  );
}
